import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/lib/analytics";

export default function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        // Give the SPA a beat to update <title> from per-page SEOHead before we send the page_view
        const t = setTimeout(() => trackPageView(pathname), 60);
        return () => clearTimeout(t);
    }, [pathname]);
    return null;
}
